<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <div class="row my-3">
                    <div class="w-full ">
                        <!-- Botón a la izquierda 
                        <button @click="goToCompanyForm(advisorId)" class="custom-create-btn me-80">
                            <span class="custom-create-btn-text">Crear Propiedad</span>
                        </button>-->
                        <!-- Buscador -->
                        <div class="flex px-4 py-[9px] bg-white rounded-md justify-end gap-2 inline-flex">
                          <!-- Input del buscador -->
                          <input
                            type="text"
                            class="grow shrink basis-0 text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            placeholder="Buscar"
                            v-model="searchQuery"
                          />
                        </div>   
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                                <tr>
                                <th class="py-3 px-6 text-style-custom text-left">ID</th>
                                <th class="py-3 px-6 text-style-custom text-left">Nombre</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estado</th>
                                <th class="py-3 px-6 text-style-custom text-left">Municipio</th>
                                <th class="py-3 px-6 text-style-custom text-left">Tipo de Inmueble</th>
                                <th class="py-3 px-6 text-style-custom text-left">Movimiento</th>
                                <th class="py-3 px-6 text-style-custom text-left">Precio</th>
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr
                                v-for="(properties, index) in filteredCargos"
                                :key="index"
                                class="border-b border-gray-200 hover:bg-gray-100"
                                >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ properties.id }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" >{{ properties.property_name }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ properties.state }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" >{{ properties.municipality }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ properties.type_property }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" >{{ properties.type_movement}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ properties.property_value}}</td>
                                <td class="py-3 px-6 text-center">
                                  <div class="relative" ref="menuContainer">
                                    <svg 
                                      @click.stop="toggleMenu(company.id)" 
                                      xmlns="http://www.w3.org/2000/svg" 
                                      width="17" 
                                      height="4" 
                                      viewBox="0 0 17 4" 
                                      fill="none" 
                                      class="cursor-pointer">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                                    </svg>
                                    <div v-show="menuVisible === company.id" class="absolute right-0 bg-white bord shadow-lg mt-1 w-48 z-10">
                                      <ul class="py-1">
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="profileCompany(properties.id)">Ver Perfil</li>
                                        <!--
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="editCargo(properties.id)">Editar</li>
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" @click="deleteCargo(company.id)">Desactivar</li>
                                        -->
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                        <DeleteModal
                          v-if="showModal"
                          :visible="showModal"
                          @close="showModal = false"
                          @confirm="confirmDelete"
                        />
                    </div>
                    <div class="flex justify-between items-center w-full">
                      <div class="w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div style="display: flex; justify-content: flex-end; align-items: center; padding: 8px 12px;">
                        <button 
                          @click="changePage(currentPage - 1)" 
                          :disabled="currentPage === 1"
                          class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :style="{padding: '8px 12px', border: '1px solid var(--Primary-Primary,  #FFD8DF)', background: 'var(--Primary-Primary, #FFF)', color: '#FF4265', opacity: page === 1 ? '0.5' : '1',cursor: page === 1 ? 'not-allowed' : 'pointer' }"
                        >
                          &lt;
                        </button>
                        
                        <!-- Números de página -->
                        <div style="display: flex; gap: 0; align-items: center;">
                            <button
                              v-for="pageNumber in totalPages" 
                              :key="pageNumber" @click="changePage(pageNumber)" 
                              :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: pageNumber === page ? '#FF4265' : 'var(--Primary-Primary, #FFF)',color: pageNumber === page ? '#FFF' : '#FF4265',fontWeight: pageNumber === page ? 'bold' : 'normal',
                                cursor: 'pointer'
                              }"
                            >
                              {{ pageNumber }}
                            </button>
                          </div>
                        
                        <button 
                          @click="changePage(currentPage + 1)" 
                          :disabled="currentPage === totalPages"
                          class="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :style="{padding: '8px 12px',border: '1px solid var(--Primary-Primary,  #FFD8DF)',background: 'var(--Primary-Primary, #FFF)',color: '#FF4265',opacity: page >= totalPages ? '0.5' : '1',cursor: page >= totalPages ? 'not-allowed' : 'pointer'
                          }"
                        >
                          &gt;
                        </button>
                      </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
    </div>        

</template>
  
  
  <script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import { useRoute } from "vue-router";
  import 'vue-toastification/dist/index.css';
  //import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/company/Modal/DeleteCompanyModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const route = useRoute();
  let userId = computed(() => route.params.id);
  //let advisorId = computed(() => route.params.id);
  const properties = ref([]);
  const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(10); // Number of items to show per page
  const isDropdownOpen = ref(false); // Inicializa el estado del dropdown

  // Métodos
  async function get_propierties() {
        try {
            let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/propertyLead/${userId.value}`;
            var options = {
            headers: {
                "Content-Type": "application/json", // Es importante establecer el tipo de contenido para el envío de archivos
                Authorization: `Bearer ${session.value.token_api}`, // Reemplaza tuTokenBearer con tu token real
            },
            };

            const response = await axios.get(url_cnn, options);

            if (response.status == 200) {
                console.log(response)
                properties.value = response.data.properties;
            }

        } catch (error) {
    
            if (error.response.status === 401) {
            store.dispatch("clearUserSession");
            router.push({ name: "login" });
            
            }
        }
        finally {
                isLoading.value = false;
        }
    }

//    const deleteCargo = (company_id) => {
//    selectedCargoId.value = company_id; // Almacena el ID del usuario
//    showModal.value = true
//  };

  const profileCompany = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'company-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  };

  async function confirmDelete() {
      try {
        // Configuración de los encabezados
        const options = {
          headers: {
            'Authorization': `Bearer ${session.value.token_api}`
          }
        };

        // Envío de la solicitud con el rol_id
        const data = { company_id: selectedCargoId.value };
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/company-delete`,
          data, 
          options
        );

        // Manejo de la respuesta
        if (response.status === 200) {
          showModal.value = false
          console.log("Cargo eliminado correctamente:", response.data.message);
          get_propierties();  
          return response.data.message; // Mensaje de éxito desde la API
          
        } else {
          console.error("Error en la respuesta de la API: estructura inesperada");
        }
      } catch (error) {
        console.error(
          "Error al intentar eliminar el cargo:",
          error.response?.data?.message || error.message
        );
      }
    }
//    const goToCompanyForm = (advisorId) => {
//    router.push({ 
//      name: 'AdvisorPropertiesCreate', 
//     params: { advisorId } // Envías el ID del asesor como parámetro
//    });
//  };
//    const editCargo = (id) => {
//      console.log("ID del rol:", id); // Imprime el ID en la consola
//      router.push({ name: 'propertyFormEdit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
//    };
    const filteredCargos = computed(() => {
        // Verificar si company.value es un array válido
        console.log(`company.value es un array:`, Array.isArray(properties.value));
        console.log(`company.value:`, properties.value);

        if (!Array.isArray(properties.value)) return [];

        // Verificar searchQuery.value
        console.log(`searchQuery.value:`, searchQuery.value);

        // Filtrar por consulta de búsqueda
        const filtered = !searchQuery.value 
            ? properties.value 
            : properties.value.filter(compani => {
                console.log(`compani:`, compani); // Verificar todo el objeto
                console.log(`compani.property_name:`, compani?.property_name); // Verificar si 'name' tiene valor
                return (compani?.property_name || '').toLowerCase().includes((searchQuery.value || '').toLowerCase());
            });

        // Paginar los resultados filtrados
        const start = (currentPage.value - 1) * itemsPerPage.value;
        const end = start + itemsPerPage.value;

        return filtered.slice(start, end);
        });

    const totalPages = computed(() => {
      const filtered = !searchQuery.value 
        ? properties.value 
        : properties.value.filter(compani => 
            compani.name.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
      return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown')) {
        isDropdownOpen.value = false;
      }
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  get_propierties();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
  </script>
  
  <style scoped>
    .card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border: none;
    border-radius: 8px;
    }
  </style>